import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed } from 'vue';
import AccessToken from '@/domain/authentication/AccessToken.ts';

const ACCESS_TOKEN_KEY = 'access_token';

export const useAccessTokenStore = defineStore('accessToken', () => {
  const tokenValue = useLocalStorage<string | null>(ACCESS_TOKEN_KEY, null);

  const accessToken = computed<AccessToken | null>(() =>
    tokenValue.value ? new AccessToken(tokenValue.value) : null,
  );

  function set(newAccessToken: AccessToken): void {
    tokenValue.value = newAccessToken.value;
  }

  function clear(): void {
    tokenValue.value = null;
  }

  return { accessToken, set, clear };
});
